// NOTE: mainにてtostifyのCSS変数を上書きするため、
// この順番でインポートする必要がある'
import 'react-toastify/dist/ReactToastify.css';
import './main.css';

import * as Sentry from '@sentry/react';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { router } from '@/app/routes';

// Sentry初期化
Sentry.init({
  dsn: 'https://f1a73a1f4a7f182b7204207d0a7fa714@o4509154896314368.ingest.us.sentry.io/4509154899197952',
  enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true'
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
